/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import MaterialTable from "material-table";
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { createTheme, ThemeProvider } from "@mui/material";
import { UpdateDataService } from './../../../Services/CrudServices';
import { DestroyResourceAction, LoadResourceAction } from "../../../Redux/Actions/CrudActions";
import { isMobile } from "react-device-detect";

const MasterFormGrid = ({ columns, dataList, setDataList, Title }) => {

    const ACTION_TYPE = "COMMON";

    const BACKEND_ROUTE = 'master-forms';

    const theme = createTheme();

    const dispatch = useDispatch();

    const navigate = useNavigate();

    const state = useSelector(state => state.common);

    const permisions = localStorage.getItem('permissions');

    const [refreshTable, setRefreshTable] = React.useState(false);

    React.useEffect(() => {
        if (refreshTable) {
            dispatch(LoadResourceAction(BACKEND_ROUTE, ACTION_TYPE));
        };
        setRefreshTable(false);
    }, [refreshTable]);

    const HandleActiveInActiveStatus = (rowData) => {
        var update_status_route = `update_resource_status/MasterForm/${rowData.id}`
        var newStatus = rowData.status === 1 ? false : true;
        var data = { '_method': 'put', 'status': newStatus };
        UpdateDataService(update_status_route, data)
            .then((res) => {
                setRefreshTable(true);
            }, error => {
                console.log("error");
            });
    }

    const handleDelete = (oldData) => {
        var ID = oldData.id;
        dispatch(DestroyResourceAction(BACKEND_ROUTE, ID, ACTION_TYPE));
    }

    return (
        <ThemeProvider theme={theme}>
            <div style={{ maxWidth: '100%' }}>
                <MaterialTable
                    // title={Title}
                    title={isMobile ? '': Title}
                    data={dataList}
                    columns={columns.columns}
                    isLoading={state.all.loading}
                    actions={[
                        {
                            hidden:permisions.includes('create_user') ? false : true,
                            icon: () => (isMobile)
                            ?<i className="fa-solid fa-plus theme-text-color-primary" style={{fontSize: '1.2rem'}}></i> 
                            :<span className="btn btn-sm btn-theme-primary ml-2">Create a Master Form</span>,
                            tooltip: 'Create a Master Form',
                            isFreeAction: true,
                            onClick: (event, rowData) => navigate("/masterform/create-form")
                        },
                        rowData => ({
                            hidden: permisions.includes('deactivate_user') ? false : true,
                            icon: () => (rowData.status)
                                ? <i className="fa-solid fa-ban text-danger" style={{ fontSize: '1.2rem' }}></i>
                                : <i className="fa-solid fa-ban text-success" style={{ fontSize: '1.2rem' }}></i>,
                            tooltip: (rowData.status) ? 'Deactivate User' : 'Activate User',
                            onClick: (event, rowData) => HandleActiveInActiveStatus(rowData),
                        }),
                    ]}
                    editable={{
                        onRowDelete: (oldData) =>
                            new Promise((resolve) => {
                                setTimeout(() => {
                                    resolve();
                                    const data = [...dataList]
                                    data.splice(data.indexOf(oldData), 1);
                                    setDataList(data)
                                    handleDelete(oldData)
                                }, 600);
                            }),
                    }}
                />
            </div>
        </ThemeProvider>
    );
}

export default MasterFormGrid;